import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { formatPrice } from "@utils/format";

import "./OutstandingCard.scss";
import { OutstandingDataType } from "@store/Outstanding";
import Swal from "sweetalert2";
import { useMst } from "@store/Route";
import { CircularProgress } from "@mui/material";

interface OutstandingCardProps extends OutstandingDataType {
  onChange: () => void;
  checked: boolean;
  token: string;
  error: boolean;
}

const OutstandingCard = ({
  checked,
  onChange,
  type,
  error,
  token,
  pdfUrl,
  accountingDocumentId,
  accountingDocumentNumber,
  description,
  originalAmount,
  remainingAmount,
  label,
  taggedCreditNotes,
}: OutstandingCardProps) => {
  const { Invoices } = useMst();

  const [isHideDetail, setIsHideDetail] = useState(true);

  /* A memoization function. It is used to cache the result of a function. */
  const typeCard = useMemo(
    () => (type === "invoice" ? "Invoice" : "Credit Note"),
    [type]
  );

  const openPdf = useCallback(() => {
    if (token && accountingDocumentId) {
      Invoices.getInvoices(token, accountingDocumentId, (callback) => {
        window.open(callback.pdfUrl);
      });
    } else {
      Swal.fire("Accounting Document Id Not Found");
    }
  }, [accountingDocumentId]);

  const projectCodeTag = useCallback(() => {
    if (label === undefined || label === null) {
      return null;
    }
    if (label === "DailyBus") {
      return (
        <label
          className={`outstandingCard__labelText`}
          style={{
            backgroundColor: "red",
          }}
        >
          Daily Bus
        </label>
      );
    }
    if (label === "Adhoc") {
      return (
        <label
          className={`outstandingCard__labelText`}
          style={{
            backgroundColor: "red",
          }}
        >
          AD-HOC
        </label>
      );
    }
  }, [label]);

  return (
    <div
      className={`w-full bg-white mb-4 rounded-md py-8 px-4 ${
        checked && !error ? "borderWidth border-blue-500" : ""
      }
      ${error ? "borderWidth !border-red-500" : ""}`}
    >
      <div className="flex flex-row space-x-4">
        <input
          type="checkbox"
          className="cursor-pointer"
          name="payment"
          value={""}
          checked={checked}
          onChange={onChange}
        />
        <div className="w-full">
          <p
            onClick={onChange}
            className={`outstandingCard__ticketNo header--18 ${
              type === "credit_note" ? "color--green" : ""
            }`}
          >{`${typeCard} - ${accountingDocumentNumber}`}</p>

          <p className="outstandingCard__descriptionText">{description}</p>

          <div className="flex flex-row items-center justify-between my-2">
            {/* <div>{projectCodeTag(projectCode, type)}</div> */}
            <div>{projectCodeTag()}</div>
            {Invoices.fetching === "pending" ? (
              <CircularProgress
                style={{
                  color: "blue",
                  marginLeft: 10,
                  marginTop: 5,
                  marginBottom: 5,
                }}
                size={20}
              ></CircularProgress>
            ) : (
              <div className="">
                <div
                  onClick={openPdf}
                  className="outstandingCard__btnTicketPDF"
                />
              </div>
            )}
          </div>
          <div className="flex flex-row space-x-10">
            {originalAmount ? (
              <div>
                <label className="lableAmount">
                  {type === "credit_note" ? "Amount" : "Original Amount"}
                </label>
                <div
                  className={`priceText
                   ${originalAmount !== remainingAmount ? "scribbleText" : ""}`}
                >
                  {`${formatPrice(originalAmount)}`}
                </div>
              </div>
            ) : null}
            {remainingAmount && originalAmount !== remainingAmount ? (
              <div className="">
                <label className="lableAmount">Remaining Amount</label>
                <div className="priceText">{`${formatPrice(
                  remainingAmount
                )}`}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {taggedCreditNotes && taggedCreditNotes.length !== 0 ? (
        <div className="w-full flex justify-end">
          <div onClick={() => setIsHideDetail(!isHideDetail)} className="hide">
            {isHideDetail ? "Show Detail" : "Hide Detail"}
          </div>
        </div>
      ) : null}
      {!isHideDetail
        ? taggedCreditNotes &&
          taggedCreditNotes.map((taggedCreditNote) => (
            <div key={taggedCreditNote.accountingDocumentNumber}>
              <div className="line" />
              <div className="row">
                <div className="col-sm-9 row">
                  <div className="lineItem" />
                  <div className="col-10">
                    <p className="onProcessCard__ticketNo header--18 color--green">
                      {`Credit Note - ${taggedCreditNote.accountingDocumentNumber}`}
                    </p>

                    {taggedCreditNote.amount ? (
                      <>
                        <label className="lableAmount">Amount</label>
                        <div className={`priceText`}>
                          {`${formatPrice(Math.abs(taggedCreditNote.amount))}`}
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          ))
        : null}
    </div>
  );
};

export default memo(OutstandingCard);
